import "./RightSideBarContent1.scss";

function RightSideBarContent1() {
  return (
    <div className="right-side-bar-content-1">
      <h1>RightSideBarContent1</h1>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
    </div>
  );
}

export default RightSideBarContent1;
